import { resultsDuckCreator } from 'axl-ducks';

const resultsDuck = resultsDuckCreator();

export default resultsDuck;
